import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  ItemContainer,
  ImageComtainer,
  ImageTagContainer,
  ImageTag,
  InfoComtainer,
  InfoTitle,
  FoldMoreContainer,
  FoldMoreTitleComtainer,
  InfoPrice,
  InfoPriceTag,
  InfoPriceNum,
  InfoDetail,
  InfoDetailVisit,
  InfoDetailLine,
  InfoDetailLoc,
  InfoTime,
  InfoTimeTag,
  InfoTimeDesc,
  FoldComtainer,
  FoldTitleComtainer,
  ItemContainerBody,
  FoldTitleText,
  FoldTitleNum,
  FoldImgComtainer,
  FoldBtn,
  DividerLine
} from './style';

import PriceItem from './PriceItem';
import CollapseAuctionItem from '../CollapseAuctionItem';
import Detail from './Detail';
import Time from './Time';
import unit_institution from "../../../store/asset_institution/unit_institution";
import { webviewRedirect,MpingClick,getBusinessTypeByMP, getUrlParms } from '../../../utils/tool'

class AuctionItem extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      collapseListHasMore: false,
      collapsePageNo: 1,
      isFinall: false,
      collapseList: []
    }
  }

  componentDidMount() {
    const lastpage = getUrlParms("lastpage") || ''
    const {itemInfo, index} = this.props;
    if (itemInfo.collapseProductList && itemInfo.collapseProductList.length) {
      MpingClick("MAuction_PublicAuctionList_FamiliarExpo",false,false, 'MAuction_PublicAuctionList',`{lastpage:${lastpage},position:${index}}`)
    }
  }

  gotoItemPage(paimaiId,index) {
    // 跳转资产单品页同时写入缓存
    const {setAssetTargetData,setTabIndex} = unit_institution;
    setAssetTargetData();
    setTabIndex();
    MpingClick("Auction_ProductList",JSON.stringify({business_type:getBusinessTypeByMP(),sort:index}))
    // 跳转到单品页
    webviewRedirect(`//mpaimai.jd.com/${paimaiId}`)
  }

  onCheck(e, index, biaoshi) {
    const lastpage = getUrlParms("lastpage") || ''
    if (biaoshi == 1) {
      MpingClick("MAuction_PublicAuctionList_Familiar",false,false, 'MAuction_PublicAuctionList',`{lastpage:${lastpage},position:${index}}`)
    }
    if (biaoshi == 2) {
      MpingClick("MAuction_PublicAuctionList_SeeMore",false,false, 'MAuction_PublicAuctionList',`{lastpage:${lastpage},position:${index}}`)
    }
    const {
      collapsePageNo
    } = this.state
    const {getCollapseAuctionList} = unit_institution;
    getCollapseAuctionList({collapseSrcPaimaiId: e.id, page: collapsePageNo}, index).then(res => {
      if (res) {
        if (res.datas && res.datas.length) {
          this.setState({
            collapseList: this.state.collapseList.concat(res.datas)
          })
        }
        if ((collapsePageNo == Math.ceil(res.totalItem/30)) || (collapsePageNo > Math.ceil(res.totalItem/30))) {
          this.setState({
            collapseListHasMore: false,
            isFinall: true
          })
        }else {
          MpingClick("MAuction_PublicAuctionList_SeeMoreExpo",false,false, 'MAuction_PublicAuctionList',`{lastpage:${lastpage},position:${index}}`)
          this.setState({
            collapseListHasMore: true,
            isFinall: false
          })
        }
        let collapsePageNoLast = parseInt(collapsePageNo);
        collapsePageNoLast += 1;
        this.setState({
          collapsePageNo: collapsePageNoLast.toString()
        })
      }else {
        this.setState({
          collapseListHasMore: false,
          isFinall: true
        })
      }
    })
  }

  getImageTag() {
    const {itemInfo} = this.props;
    const supportLoan = itemInfo && itemInfo.loan === 1;
    if ( supportLoan || itemInfo.purchaseRestriction) {
      return (
        <ImageTagContainer>
          {
            supportLoan && <ImageTag
              bgColor={'#e3874c'}
              color={'#ffffff'}
            >可贷款</ImageTag>
          }
          {
            itemInfo.purchaseRestriction==1 && <ImageTag
              bgColor={'#f6e38b'}
              color={'#a55300'}
            >不限购</ImageTag>
          }
        </ImageTagContainer>
      );
    }
    return null;
  }

  render() {
    const {
      collapseListHasMore,
      isFinall,
      collapseList
    } = this.state
    const {itemInfo, realTimeData,index} = this.props;
    return (
      <ItemContainerBody>
        <ItemContainer className="auction-item" onClick={() => {
          this.gotoItemPage(itemInfo.id,index);
        }} data-paimaiid={itemInfo.id}>
          <ImageComtainer>
            {
              this.getImageTag()
            }
            <img src={`//img1${itemInfo.id % 5}.360buyimg.com/imgw/s480x320_${itemInfo.productImage}!cc_3x2!q85`}></img>
          </ImageComtainer>
          <InfoComtainer>
            <InfoTitle>{itemInfo.title}</InfoTitle>
            <PriceItem
              realTimeData={realTimeData}
              itemInfo={itemInfo}></PriceItem>
            <Detail
              realTimeData={realTimeData}
              itemInfo={itemInfo}></Detail>
            <Time
              realTimeData={realTimeData}
              itemInfo={itemInfo}
            ></Time>
          </InfoComtainer>
        </ItemContainer>
        {collapseList.length !== 0 && collapseList.map(
              (value,index) => (<CollapseAuctionItem
                index={index}
                key={value.id}
                itemInfo={value}
                realTimeData={unit_institution.realTimeData[value.id]}
              ></CollapseAuctionItem>))}
        {(!collapseListHasMore && !isFinall && itemInfo.collapseProductList && itemInfo.collapseProductList.length) && <FoldComtainer>
          <FoldTitleComtainer>
            <FoldTitleText>同类型拍品</FoldTitleText>
            <FoldTitleNum>共 <FoldTitleNum isNum={true}>{itemInfo.collapseProductTotalNum}</FoldTitleNum> 件</FoldTitleNum>
          </FoldTitleComtainer>
          <FoldImgComtainer>
            {
              itemInfo.collapseProductList.length > 3 ? itemInfo.collapseProductList.slice(0, 3).map(item => (
                <img className="img" src={`//img1${item.id % 5}.360buyimg.com/imgw/s480x320_${item.productImage}!cc_2x2!q85`}></img>
              )) : itemInfo.collapseProductList.map(item => (
                <img className="img" src={`//img1${item.id % 5}.360buyimg.com/imgw/s480x320_${item.productImage}!cc_2x2!q85`}></img>
              ))
            }
          </FoldImgComtainer>
          <FoldBtn onClick={()=>{this.onCheck(itemInfo, index, 1)}}>展开</FoldBtn>
        </FoldComtainer>}
        {
          collapseListHasMore && <FoldMoreContainer>
            <FoldMoreTitleComtainer>
              <FoldTitleText>继续查看同类型拍品 </FoldTitleText>
            </FoldMoreTitleComtainer>
            <FoldBtn onClick={()=>{this.onCheck(itemInfo, index, 2)}}>展开</FoldBtn>
          </FoldMoreContainer>
        }
        {
          !collapseListHasMore && isFinall && <DividerLine><span>下方为该机构其他拍品</span></DividerLine>
        }
      </ItemContainerBody>
    )
  }
}

export default AuctionItem;
